import { InjectionToken } from '@angular/core';

/**
 * @description    Create a simple date from the date object
 * @param dateObj  Date object
 * @param locale   Locale used to format the date
 */
export const getSimpleDateFromDateObject = (dateObj: Date, locale: string): string => {
    const month = dateObj.toLocaleDateString(locale, { month: '2-digit' });
    const day = dateObj.toLocaleDateString(locale, { day: '2-digit' });

    return dateObj.getFullYear() + '-' + month + '-' + day;
};

export type GetSimpleDateFromDateObjectProvider = (dateObj: Date, locale: string) => string;
export const GET_SIMPLE_DATE_FROM_DATE_OBJECT =
    new InjectionToken('GET_SIMPLE_DATE_FROM_DATE_OBJECT', {
        factory: () => getSimpleDateFromDateObject
    });
